import { type ComponentPropsWithoutRef, type ForwardedRef, forwardRef, memo } from 'react';
import { PageActionDiscriminator } from 'autogen/swagger/all';
import type { operations } from 'autogen/swagger/all/all';
import CustomAction from './components/CustomAction/CustomAction';
import LinkAction from './components/LinkAction/LinkAction';

export type PageActionModel = operations['PageActionModel']['responses']['200']['content']['application/json'];

export type PageActionProps = {
    action: PageActionModel;
} & ComponentPropsWithoutRef<'a'> &
    ComponentPropsWithoutRef<'button'>;

const PageAction = forwardRef<HTMLAnchorElement | HTMLButtonElement, PageActionProps>((props, ref) => {
    const { action, ...restProps } = props;

    return PageActionDiscriminator(
        action,
        (customPageAction) => (
            <CustomAction
                action={customPageAction.action}
                ref={ref as ForwardedRef<HTMLButtonElement>}
                {...restProps}
            />
        ),
        (linkAction) => (
            <LinkAction action={linkAction.action} ref={ref as ForwardedRef<HTMLAnchorElement>} {...restProps} />
        ),
        () => null
    );
});

export default memo(PageAction);
